import Service from "./Service";

class ClientSettingApiService extends Service {
  constructor() {
    super("api/ClientAppSettings");
  }

  async GetTotalCostMax() {
    let result = await this.get(`/GetTotalCostMax`, (status, data) => {
      return data;
    });
    return result;
  }

  async GetAllowedFileExtension() {
    let result = await this.get(`/AllowedFileExtensions`, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new ClientSettingApiService();
